export default __webpack_public_path__ + "static/BasisGrotesque-Medium-0d4e6a6ba7922c96608a6044663fceb8.woff2";